import PropTypes from "prop-types";
import React from "react";
import { createUseStyles, useTheme } from "react-jss";
import CountUp from "react-countup";
import { COUNTER_DURATION_SEC } from "../calculationParams";

const useStyles = createUseStyles({
  resultComparisonContainer: {
    marginTop: 24,
    marginBottom: 24,
    display: "flex",
    flexGrow: 1,
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "flex-start",
    paddingLeft: 16,
    borderLeft: ({ theme }) => `1px solid ${theme.dustinBorderDivider}`,
    "@media (min-width: 500px) and (max-width: 991px)": {
      minWidth: "calc(50% - 32px)",
    },
  },
  copy: {
    display: "block",
    fontSize: 16,
    lineHeight: "19px",
    fontWeight: 400,
    color: "white",
    marginTop: 24,
    marginBottom: 24,
    "@media (max-width: 991px)": {
      fontSize: 14,
      lineHeight: "16px",
    },
  },
  amount: {
    display: "block",
    fontSize: 96,
    lineHeight: "116px",
    margin: 0,
    color: ({ theme }) => theme.dustinGreen,
    "@media (max-width: 991px)": {
      fontSize: 48,
      lineHeight: "57.6px",
    },
  },
});

export const ResultComparisonUnit = ({ topCopy, amount, bottomCopy }) => {
  const theme = useTheme();
  const classes = useStyles({ theme });

  return (
    <div
      className={classes.resultComparisonContainer}
    >
      <div className={classes.copy}>{topCopy}</div>
      <div className={classes.amount}>
        <CountUp duration={COUNTER_DURATION_SEC} end={amount} separator={" "} />
      </div>
      <div className={classes.copy}>{bottomCopy}</div>
    </div>
  );
};

ResultComparisonUnit.propTypes = {
  topCopy: PropTypes.string.isRequired,
  amount: PropTypes.number.isRequired,
  bottomCopy: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/ResultComparisonUnit.js